module.exports = __webpack_public_path__ + "static/img/search_subcat_item_05_show.a43a278.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/shared/assets/images/release/search_subcat_item_05_show.jpg
// module id = GbH7
// module chunks = 0